// Mirrors supabase/functions/moderate-content/selfHarm.ts — keep both in sync.
const PATTERNS: RegExp[] = [
  /\b(i|i'm|im|i've|ive|been|started|keep|kept)\b[^.!?\n]{0,30}\b(cutting|cut|burn(ing|ed)?|hurt(ing)?|harm(ing)?)\s+(myself|my\s+(arm|arms|wrist|wrists|leg|legs|thigh|thighs|skin))\b/i,
  /\bself[\s-]?harm(ing|ed)?\b/i,
  /\b(kill|end|ending|take|taking)\s+(myself|my\s+(own\s+)?life)\b/i,
  /\b(want|wanna|going|plan(ning)?)\s+(to\s+)?die\b/i,
  /\bsuicid(e|al)\b/i,
  /\boverdos(e|ed|ing)\b/i,
  /\b(slit|slitting)\s+my\b/i,
];

export function detectSelfHarm(text: string): boolean {
  if (!text) return false;
  return PATTERNS.some((p) => p.test(text));
}
